import type { SvgProps } from "components/icons/types";

// fi-rs-cross-small — small X; natural ~9x9 aspect.
export const FiCross = (props: SvgProps) => (
  <svg
    width="9"
    height="9"
    viewBox="0 0 6.707 6.707"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.707 0.707L6 0L3.3535 2.6465L0.707 0L0 0.707L2.6465 3.3535L0 6L0.707 6.707L3.3535 4.0605L6 6.707L6.707 6L4.0605 3.3535L6.707 0.707Z"
      fill="currentColor"
    />
  </svg>
);
